import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/* Copyright (C) 2018 TeselaGen Biotechnology, Inc. */
import { camelCase, flatMap, remove, startsWith } from "lodash";
import { loadAsync } from "jszip";
import _Promise from "bluebird";
import { parse, unparse } from "papaparse";
import { snakeCase } from "lodash";

var logDebug = function logDebug() {
  if (process.env.DEBUG_CSV_PARSING) {
    var _console;

    // eslint-disable-next-line no-console
    (_console = console).log.apply(_console, arguments);
  }
};

export var allowedCsvFileTypes = [".csv", ".txt", ".xlsx"];
export var isZipFile = function isZipFile(file) {
  var type = file.mimetype || file.type;
  return type === "application/zip" || type === "application/x-zip-compressed";
};
export var getExt = function getExt(file) {
  return file.name.split(".").pop();
};
export var isExcelFile = function isExcelFile(file) {
  return getExt(file) === "xlsx";
};
export var isCsvFile = function isCsvFile(file) {
  return getExt(file) === "csv";
};
export var isTextFile = function isTextFile(file) {
  return ["text", "txt"].includes(getExt(file));
};
export var isCsvOrExcelFile = function isCsvOrExcelFile(file) {
  return isCsvFile(file) || isExcelFile(file);
};
export var extractZipFiles = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(allFiles) {
    var zipFiles, zipFilesArray, parsedZips, zippedFiles, unzippedFiles;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!Array.isArray(allFiles)) allFiles = [allFiles]; // make a copy so we don't mutate the form value

            allFiles = [].concat(allFiles);
            zipFiles = remove(allFiles, isZipFile);

            if (zipFiles.length) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", allFiles);

          case 5:
            zipFilesArray = Array.isArray(zipFiles) ? zipFiles : [zipFiles];
            _context.next = 8;
            return _Promise.map(zipFilesArray, function (file) {
              return loadAsync(file instanceof Blob ? file : file.originFileObj);
            });

          case 8:
            parsedZips = _context.sent;
            zippedFiles = flatMap(parsedZips, function (zip) {
              return Object.keys(zip.files).map(function (key) {
                return zip.files[key];
              });
            });
            _context.next = 12;
            return _Promise.map(zippedFiles, function (file) {
              // converts the compressed file to a string of its contents
              return file.async("blob").then(function (fileData) {
                var newFileObj = new File([fileData], file.name);
                return {
                  name: file.name,
                  originFileObj: newFileObj,
                  originalFileObj: newFileObj
                };
              });
            });

          case 12:
            unzippedFiles = _context.sent;

            if (!unzippedFiles.length) {
              _context.next = 17;
              break;
            }

            return _context.abrupt("return", allFiles.concat(unzippedFiles.filter(function (_ref2) {
              var name = _ref2.name,
                  originFileObj = _ref2.originFileObj;
              return !name.includes("__MACOSX") && !name.includes(".DS_Store") && originFileObj.size !== 0;
            })));

          case 17:
            return _context.abrupt("return", allFiles);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function extractZipFiles(_x) {
    return _ref.apply(this, arguments);
  };
}();
var defaultCsvParserOptions = {
  header: true,
  skipEmptyLines: "greedy",
  trimHeaders: true
};
export var setupCsvParserOptions = function setupCsvParserOptions(parserOptions) {
  if (parserOptions === void 0) {
    parserOptions = {};
  }

  var _parserOptions = parserOptions,
      _parserOptions$camelC = _parserOptions.camelCaseHeaders,
      camelCaseHeaders = _parserOptions$camelC === void 0 ? false : _parserOptions$camelC,
      _parserOptions$lowerC = _parserOptions.lowerCaseHeaders,
      lowerCaseHeaders = _parserOptions$lowerC === void 0 ? false : _parserOptions$lowerC,
      rest = _objectWithoutPropertiesLoose(_parserOptions, ["camelCaseHeaders", "lowerCaseHeaders"]);

  var papaParseOpts = _extends({}, rest);

  if (camelCaseHeaders) {
    logDebug("[CSV-PARSER] camelCasing headers");

    papaParseOpts.transformHeader = function (header) {
      var transHeader = header;

      if (!startsWith(header.trim(), "ext-")) {
        transHeader = camelCase(header);
      }

      if (transHeader) {
        logDebug("[CSV-PARSER] Transformed header from: " + header + " to: " + transHeader);
        transHeader = transHeader.trim();
      } else {
        logDebug("[CSV-PARSER] Not transforming header: " + header);
      }

      return transHeader;
    };
  } else if (lowerCaseHeaders) {
    papaParseOpts.transformHeader = function (header) {
      var transHeader = header;

      if (!startsWith(header, "ext-")) {
        transHeader = header.toLowerCase();
      }

      if (transHeader) {
        logDebug("[CSV-PARSER] Transformed header from: " + header + " to: " + transHeader);
        transHeader = transHeader.trim();
      } else {
        logDebug("[CSV-PARSER] Not transforming header: " + header);
      }

      return transHeader;
    };
  }

  return papaParseOpts;
};

var normalizeCsvHeaderHelper = function normalizeCsvHeaderHelper(h) {
  return snakeCase(h.toUpperCase()).toUpperCase();
};

export function normalizeCsvHeader(header) {
  if (header.startsWith("ext-") || header.startsWith("EXT-")) {
    return header;
  }

  return normalizeCsvHeaderHelper(header);
}
export var parseCsvFile = function parseCsvFile(csvFile, parserOptions) {
  if (parserOptions === void 0) {
    parserOptions = {};
  }

  return new _Promise(function (resolve, reject) {
    var opts = _extends({}, defaultCsvParserOptions, setupCsvParserOptions(parserOptions), {
      complete: function complete(results) {
        if (results && results.errors && results.errors.length) {
          return reject("Error in csv: " + JSON.stringify(results.errors));
        }

        resolve(results);
      },
      error: function error(_error) {
        reject(_error);
      }
    });

    logDebug("[CSV-PARSER] parseCsvFile opts:", opts);
    parse(csvFile.originFileObj, opts);
  });
};
/**
 * Gets a properly formatted json object into s csv string
 * https://www.papaparse.com/docs#json-to-csv
 * const options = {
      quotes: false, //or array of booleans
      quoteChar: '"',
      escapeChar: '"',
      delimiter: ",",
      header: true,
      newline: "\r\n",
      skipEmptyLines: false, //other option is 'greedy', meaning skip delimiters, quotes, and whitespace.
      columns: null //or array of strings
    }
 * @returns csv as string
 */

export var jsonToCsv = function jsonToCsv(jsonData, options) {
  if (options === void 0) {
    options = {};
  }

  var csv = unparse(jsonData, options);
  return csv;
};
export var parseCsvString = function parseCsvString(csvString, parserOptions) {
  if (parserOptions === void 0) {
    parserOptions = {};
  }

  var opts = _extends({}, defaultCsvParserOptions, setupCsvParserOptions(parserOptions));

  logDebug("[CSV-PARSER] parseCsvString opts:", opts);
  return parse(csvString, opts);
};
export function parseCsvOrExcelFile(_x2, _x3) {
  return _parseCsvOrExcelFile.apply(this, arguments);
}

function _parseCsvOrExcelFile() {
  _parseCsvOrExcelFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(fileOrFiles, _temp) {
    var _ref3, csvParserOptions, csvFile, excelFile, txtFile, parsedCsv;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _ref3 = _temp === void 0 ? {} : _temp, csvParserOptions = _ref3.csvParserOptions;

            if (Array.isArray(fileOrFiles)) {
              csvFile = fileOrFiles.find(isCsvFile);
              excelFile = fileOrFiles.find(isExcelFile);
              txtFile = fileOrFiles.find(isTextFile);
            } else {
              if (isExcelFile(fileOrFiles)) excelFile = fileOrFiles;else if (isCsvFile(fileOrFiles)) csvFile = fileOrFiles;else if (isTextFile(fileOrFiles)) txtFile = fileOrFiles;
            }

            if (!(!csvFile && !excelFile && !txtFile)) {
              _context3.next = 4;
              break;
            }

            throw new Error("No csv or excel files found");

          case 4:
            if (!csvFile && !excelFile) csvFile = txtFile;

            if (!(!csvFile && excelFile && window.parseExcelToCsv)) {
              _context3.next = 13;
              break;
            }

            _context3.next = 8;
            return window.parseExcelToCsv(excelFile.originFileObj || excelFile);

          case 8:
            csvFile = _context3.sent;

            if (!csvFile.error) {
              _context3.next = 11;
              break;
            }

            throw new Error(csvFile.error);

          case 11:
            _context3.next = 15;
            break;

          case 13:
            if (!excelFile) {
              _context3.next = 15;
              break;
            }

            throw new Error("Excel Parser not initialized on the window");

          case 15:
            _context3.next = 17;
            return parseCsvFile(csvFile, csvParserOptions);

          case 17:
            parsedCsv = _context3.sent;
            parsedCsv.originalFile = csvFile;
            return _context3.abrupt("return", parsedCsv);

          case 20:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _parseCsvOrExcelFile.apply(this, arguments);
}

export var validateCSVRequiredHeaders = function validateCSVRequiredHeaders(fields, requiredHeaders, filename) {
  var missingRequiredHeaders = requiredHeaders.filter(function (field) {
    return !fields.includes(field);
  });

  if (missingRequiredHeaders.length) {
    var name = filename ? "The file " + filename : "CSV file";
    return name + " is missing required headers. (" + missingRequiredHeaders.join(", ") + ")";
  }
};
export var validateCSVRow = function validateCSVRow(row, requiredHeaders, index) {
  var missingRequiredFields = requiredHeaders.filter(function (field) {
    return !row[field];
  });

  if (missingRequiredFields.length) {
    if (missingRequiredFields.length === 1) {
      return "Row " + (index + 1) + " is missing the required field \"" + missingRequiredFields[0] + "\"";
    } else {
      return "Row " + (index + 1) + " is missing these required fields: " + missingRequiredFields.join(", ");
    }
  }
};
export var cleanCommaSeparatedCell = function cleanCommaSeparatedCell(cellData) {
  return (cellData || "").split(",").map(function (n) {
    return n.trim();
  }).filter(function (n) {
    return n;
  });
};
/**
 * Because the csv rows might not have the same header keys in some cases (extended properties)
 * this function will make sure that each row will have all headers so that the export
 * does not drop fields
 * @param {*} rows
 */

export var cleanCsvExport = function cleanCsvExport(rows) {
  var allHeaders = [];
  rows.forEach(function (row) {
    Object.keys(row).forEach(function (header) {
      if (!allHeaders.includes(header)) {
        allHeaders.push(header);
      }
    });
  });
  rows.forEach(function (row) {
    allHeaders.forEach(function (header) {
      row[header] = row[header] || "";
    });
  });
  return rows;
};
export var filterFilesInZip = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file, accepted) {
    var zipExtracted, acceptedFiles, _loop, _iterator, _step;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return extractZipFiles(file);

          case 2:
            zipExtracted = _context2.sent;
            acceptedFiles = [];

            _loop = function _loop() {
              var extFile = _step.value;
              var extension = "." + getExt(extFile);

              if (accepted.some(function (ext) {
                return ext === extension;
              })) {
                acceptedFiles.push(extFile);
              }
            };

            for (_iterator = _createForOfIteratorHelperLoose(zipExtracted); !(_step = _iterator()).done;) {
              _loop();
            }

            if (acceptedFiles.length && acceptedFiles.length < zipExtracted.length) window.toastr.warning("Some files don't have the proper file extension.");
            if (!acceptedFiles.length) window.toastr.warning("No files with the proper extension were found.");
            return _context2.abrupt("return", acceptedFiles);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function filterFilesInZip(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();
export function removeExt(filename) {
  if (filename && filename.includes(".")) {
    return filename.split(".").slice(0, -1).join(".");
  } else {
    return filename;
  }
}
export function uploadAndProcessFiles(_x6) {
  return _uploadAndProcessFiles.apply(this, arguments);
}

function _uploadAndProcessFiles() {
  _uploadAndProcessFiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(files) {
    var formData, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (files === void 0) {
              files = [];
            }

            if (files.length) {
              _context4.next = 3;
              break;
            }

            return _context4.abrupt("return", null);

          case 3:
            formData = new FormData();
            files.forEach(function (_ref5) {
              var originFileObj = _ref5.originFileObj;
              return formData.append("file", originFileObj);
            });
            _context4.next = 7;
            return window.api.post("/user_uploads/", formData);

          case 7:
            response = _context4.sent;
            return _context4.abrupt("return", response.data.map(function (d) {
              return {
                encoding: d.encoding,
                mimetype: d.mimetype,
                originalname: d.originalname,
                path: d.path,
                size: d.size
              };
            }));

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _uploadAndProcessFiles.apply(this, arguments);
}

export function encodeFilesForRequest(_x7) {
  return _encodeFilesForRequest.apply(this, arguments);
}

function _encodeFilesForRequest() {
  _encodeFilesForRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(files) {
    var encodedFiles, _iterator2, _step2, file, encoded, data;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            encodedFiles = [];
            _iterator2 = _createForOfIteratorHelperLoose(files);

          case 2:
            if ((_step2 = _iterator2()).done) {
              _context5.next = 11;
              break;
            }

            file = _step2.value;
            _context5.next = 6;
            return fileToBase64(file.originalFileObj);

          case 6:
            encoded = _context5.sent;
            data = encoded.split(",");
            encodedFiles.push({
              type: file.type,
              base64Data: data[1],
              name: file.name
            });

          case 9:
            _context5.next = 2;
            break;

          case 11:
            return _context5.abrupt("return", encodedFiles);

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _encodeFilesForRequest.apply(this, arguments);
}

var fileToBase64 = function fileToBase64(file) {
  return new _Promise(function (resolve) {
    var reader = new FileReader(); // Read file content on file loaded event

    reader.onload = function (event) {
      resolve(event.target.result);
    }; // Convert data to base64


    reader.readAsDataURL(file);
  });
};